var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logout",attrs:{"href":_vm.config.cas_domin+'/bridge/do_logout.html?redirect='+encodeURIComponent(_vm.config.cas_domin+'/#/login?redirect='+encodeURIComponent(_vm.config.apps_domain+'/m/#/'))}},[_vm._v("退出当前登录")])}
var staticRenderFns = []

export { render, staticRenderFns }